import styled from 'styled-components'

export default styled.section`
   padding: 3.375rem ${props => props.theme.padding.inner} 3.625rem;
  overflow: hidden;

img{
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 49px;
   }

     
.caption-container{
    margin: auto;
    display: flex;
    gap: 48px;
    align: center;
    flex-wrap: wrap;
    max-width: 1339px;
    justify-content: center;
    
}
    .caption-item{
        justify-items: center;
        text-align: center;
        width: 390px;

        h2{
            margin: 0;
            padding-bottom: 3px;
        }

        p{
            margin: 0;
            padding-top: 8px;
            font-size: 16px;
            font-weight: 400;
            line-height: 27px;
        }
    }

    

    

`